module.exports = __webpack_public_path__ + "static/img/szg.456a7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/szg.png
// module id = 4NkC
// module chunks = 1